import { localStorage } from '../../kodyl/web-storage';
import config from '../config';

const methods = ['get', 'post', 'put', 'delete'];

export default class ApiClient {
  constructor({ host = '' } = {}) {
    this.host = host;

    methods.forEach(
      method =>
        (this[method] = (path, options = {}) =>
          this.fetch(path, { ...options, method }))
    );
  }

  formatUrl(path /*, params*/) {
    return `${this.host}${path[0] !== '/' ? '/' : ''}${path}`;
  }

  fetch(path, { params, data, method = 'get', type } = {}) {
    const headers = {
      Accept: 'application/json'
    };

    if (type !== null) {
      headers['Content-Type'] = type || 'application/json';
    }

    const opts = {
      method,
      headers
    };

    if (__CLIENT__) {
      const token = localStorage.getItem(config.ls_token);
      if (token) {
        headers.Authorization = `Bearer ${token}`;
      }

      // const { fetch: config = {} } = global.__bncfg;
      // if (config.credentials) {
      //   opts.credentials = config.credentials;
      // }
    }

    if (data) {
      opts.body = type !== undefined ? data : JSON.stringify(data);
    }

    return fetch(this.formatUrl(path, params), opts).then(response => {
      return response
        .json()
        .then(json => {
          if (response.status >= 200 && response.status < 300) {
            return json;
          }
          const err = new Error(`HTTP_${response.status}`);
          err.response = json;
          err.statusCode = response.status;
          throw err;
        })
        .catch(err => {
          if (err && err.statusCode) {
            throw err;
          }

          err = new Error(`HTTP_${response.status}`);
          err.statusCode = response.status;
          throw err;
        });
    });
  }
}
